<template>
  <div class="player">
    <!-- <iframe
      class="vjs-custom-skin"
      ref="youkuPlayer"
      frameborder=0
      allowfullscreen
    >
    </iframe> -->
    <div id="youkuplayer" class="vjs-custom-skin"></div>
    <div id="cover"></div>
    <!-- advertisement tip -->
    <div class="tips" v-if="timing">
      <span class="timing">{{timing}}</span>
      <div class="vip-close" @click="vipClose()">
        <span>VIP可关闭广告</span>
        <span>X</span>
      </div>
    </div>

    <!-- videoAd click jump -->
    <div class="jump-ad" v-if="timing">
      <a :href="`//${mediaInfo.startAd.link}`" target="_blank" @click="insertAdcount(2, mediaInfo.startAd.id)"></a>
    </div>

    <!-- pause advertisement -->
    <div class="pause-ads" v-show="pause && mediaInfo.pauseAd">
      <span class="close" @click="pause = false">关闭</span>
      <a v-if="mediaInfo && mediaInfo.pauseAd" :href="`//${mediaInfo && mediaInfo.pauseAd.link}`" target="_blank" @click="insertAdcount(2, mediaInfo.pauseAd.id)">
        <img :src="`/realNet/file/${mediaInfo && mediaInfo.pauseAd.file }`" alt="暂停广告">
      </a>
    </div>

    <!-- purchase video -->
    <div class="limit-watch" v-if="vip">
      <span>免费试看<span class="sample">{{sample}}分钟</span>，</span>
      <!-- <span v-if="mediaInfo.chargeType === 2">该视频为VIP专享，点击<span class="purchase" @click="purchase('vip')">开通VIP</span>观看完整视频</span> -->
      <!-- <span v-if="mediaInfo.chargeType === 1">该视频为付费内容，点击<span class="purchase" @click="purchase({ id: +mediaInfo.videoInfo.id, name: mediaInfo.name, money: mediaInfo.money })">购买</span>观看完整视频</span> -->
      <span v-if="!mediaInfo.permission">该视频为付费内容，点击<span class="purchase" @click="purchase({ id: +mediaInfo.videoInfo.id, name: mediaInfo.name, money: mediaInfo.money })">购买</span>观看完整视频</span>
    </div>

    <!--
      <div class="video-information">
          <ul class="video-left">
              <li>
                  <span class="video-icon"><i class="fa fa-play-circle-o"></i></span>
                  <span>6329万</span>
              </li>
              <li>
                  <span class="video-icon"><i class="fa fa-thumbs-o-up"></i></span>
                  <span>1287</span>
              </li>
              <li>
                  <span class="video-icon"><i class="fa fa-thumbs-o-down"></i></span>
                  <span>23</span>
              </li>
          </ul>
          <ul class="video-right">
              <share-com></share-com>
              <li>
                  <span class="video-icon"><i class="fa fa-download"></i></span>
                  <span>下载</span>
              </li>
              <li>
                  <span class="video-icon"><i class="fa fa-info-circle"></i></span>
                  <span>举报</span>
              </li>
          </ul>
      </div>
    -->
  </div>
</template>

<script>
// import $ from 'jquery'
import ShareCom from '@/components/zhangqi/ShareCom.vue'
import { getToken, getUser } from '../../utils/auth.js'


export default {
  components: {
    ShareCom
  },
  props: ['source', 'thumb', 'mediaInfo',"videoSource"],
  data() {
    return {
      autoPlay: true,
      pause: false,
      vip: false,
      sample: 6,
      // videojs options
      playerOptions: {
        height: '576',
        preload: true,
        muted: false,
        language: 'zh-CN',
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        flash: { hls: { withCredentials: false } },
        html5: { hls: { withCredentials: false } },
        sources: []
      },
      timing: 0,
      timer: null,
      timetick: 0,
      playOn: true,
      showTips: false
    }
  },
  computed: {
    querier: function() {
      return this.$http ? this.$http : this.$axios
    }
  },
  watch: {
    mediaInfo() {
      this.playOn = true
    },
    source: function() {
      if (this.source) {
        var that = this
        if (this.playerOptions.sources.length > 0) {
          // 清除之前视频的计时器
          clearInterval(this.timer)
          this.source.map(function(src, i) {
            that.$set(that.playerOptions.sources, i, src)
          })
        } else {
          this.source.map(function(src) {
            that.playerOptions.sources.push(src)
          })
        }
      }
    },
    thumb: function() {
      this.playerOptions.poster = this.thumb
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  mounted() {
    this.youkuUrl()
  },
  methods: {
    // 获取视频的链接放到iframe
    youkuUrl() {
    },
    playerLog(err) {
      // console.log(err)
    },
    onReady(player) {
      player.autoplay(true)

      var xhr = window.videojs.Hls
        ? window.videojs.Hls.xhr
        : window.videojs.xhr
      if (xhr) {
        xhr.beforeRequest = function(req) {
          if (req.headers == null) {
            req.headers = {}
          }
          req.headers.token = getToken()
          return req
        }
      }
    },
    autoStart(player) {
      console.log('autostart')

      if (window._hmt) {
        window._hmt.push([
          '_trackEvent',
          '视频播放',
          this.mediaInfo.name + '_第' + this.mediaInfo.episode + '集'
        ])
      }
      if (this.autoPlay && this.playOn) {
        player.play()
      }
    },
    /*
    setForwardControl() {
        var $vjsPlayControl = $("button.vjs-play-control")
        $vjsPlayControl.after(
            `<button class="vjs-step-forward-control vjs-control vjs-button vjs-paused" type="button" title="step-forward" aria-disabled="false">
                <span aria-hidden="true" class="fa fa-step-forward"></span>
                <span class="vjs-control-text" aria-live="polite">step-forward</span>
            </button>`
        )
        $(".vjs-step-forward-control").click(() => {
            $vjsPlayControl.after(
                `<button class="vjs-step-forward-control vjs-control vjs-button vjs-paused" type="button" title="step-forward" aria-disabled="false">
                    <span aria-hidden="true" class="fa fa-step-forward"></span>
                    <span class="vjs-control-text" aria-live="polite">step-forward</span>
                </button>`
            )
        })
    },
    setCogControl() {
        var $vjsFullscreenControl = $("button.vjs-fullscreen-control")
        $vjsFullscreenControl.before(
            `<button class="vjs-cog-control vjs-control vjs-button" type="button" title="step-forward" aria-disabled="false">
                <span aria-hidden="true" class="fa fa-cog"></span>
                <span class="vjs-control-text" aria-live="polite">step-forward</span>
            </button>`
        )
    },
    setClarityControl() {
        var $vjsPlaybackRate = $("div.vjs-playback-rate")
        $vjsPlaybackRate.before(
            `<div class="vjs-clarity vjs-menu-button vjs-menu-button-popup vjs-control vjs-button">
                <button class="vjs-clarity vjs-menu-button vjs-menu-button-popup vjs-button" type="button" aria-disabled="false"
                    title="clarity Rate" aria-haspopup="true" aria-expanded="false">
                    <span aria-hidden="true" class="vjs-icon-placeholder"></span>
                    <span class="vjs-control-text" aria-live="polite">Clarity</span>
                </button>
                <div class="vjs-menu">
                    <ul class="vjs-menu-content" role="menu">
                        <li class="vjs-menu-item" tabindex="-1" role="menuitemradio" aria-disabled="false" aria-checked="false">
                            <span class="vjs-menu-item-text">超清</span>
                            <span class="vjs-control-text" aria-live="polite"></span>
                        </li>

                        <li class="vjs-menu-item vjs-selected" tabindex="-1" role="menuitemradio" aria-disabled="false" aria-checked="false">
                            <span class="vjs-menu-item-text">高清</span>
                            <span class="vjs-control-text" aria-live="polite"></span>
                        </li>
                            <li class="vjs-menu-item" tabindex="-1" role="menuitemradio" aria-disabled="false" aria-checked="false">
                            <span class="vjs-menu-item-text">标清</span>
                            <span class="vjs-control-text" aria-live="polite"></span>
                        </li>
                    </ul>
                </div>
                <div class="vjs-clarity-value">高清</div>
            </div>`
        )
    },
    */
    onPlayerPlay(player) {
      // 重置状态是否付费观看状态
      this.vip = false
      let duration = Math.floor(player.duration())
      this.pause = false
      // 是否有开始广告
      if (this.source[0].sign) {
        this.insertAdcount(1, this.mediaInfo.startAd.id)
        this.timing = duration
        this.timer = setInterval(() => {
          this.timing--
          if (!this.timing) {
            clearInterval(this.timer)
          }
        }, 1000)
      } else {
        let parentNode = document.querySelector('.video-player > .video-js')
        let pauseAd = document.querySelector('.pause-ads')
        pauseAd && parentNode.appendChild(pauseAd)
        // 是否为付费内容
        if (!this.mediaInfo.permission) {
          this.vip = true
          // 是否需要VIP
          // if (this.mediaInfo.chargeType === 2) {
          //   if(!this.checkVip('notips')) {
          //     this.vip = true
          //   }
          // } else if (this.mediaInfo.chargeType === 1) {
          //   this.vip = true
          // }
        }
      }
      this.playOn = true
    },
    onPlayerPause(player) {
      this.pause = true
      this.insertAdcount(1, this.mediaInfo.pauseAd.id)
    },
    endPlay(player) {
      // 判断当前是否为广告
      if (this.source[0].sign) {
        // 播放完毕移除广告source
        this.source.shift()
        return
      }
      player.currentTime(0)
      this.timetick = 0
      this.playOn = false
      this.saveRemainTime(0, 0)
      localStorage.removeItem(
        'currentTime_' + this.mediaInfo.videoInfo.id + '_' + this.mediaInfo.episode
      )
      this.$emit('endPlay')
    },
    onPlayerTimeupdate(player) {
      // 广告不保存断点
      if (!this.source[0].sign) {
        // 试看内容不保存断点
        // if (this.mediaInfo.chargeType === 2 && Math.floor(player.currentTime()) === this.sample * 60 - 2 && !this.showTips) {
        //   this.callPay('试看结束，请开通VIP继续观看')
        //   this.showTips = true
        //   return false
        // }
        // if (this.mediaInfo.chargeType === 1 && Math.floor(player.currentTime()) === this.sample * 60 - 2 && !this.showTips) {
        //   this.callPay('试看结束，请购买该视频继续观看', { id: +this.mediaInfo.videoInfo.id, name: this.mediaInfo.name, money: this.mediaInfo.money })
        //   this.showTips = true
        //   return false
        // }
        if (!this.mediaInfo.permission && Math.floor(player.currentTime()) >= this.sample * 60 - 2 && !this.showTips) {
          this.callPay('试看结束，请购买该视频继续观看', { id: +this.mediaInfo.videoInfo.id, name: this.mediaInfo.name, money: this.mediaInfo.money })
          this.showTips = true
          return false
        }
        if (player.duration() && this.playOn) {
          let duration = Math.floor(player.duration())
          let currentTime = Math.floor(player.currentTime())
          let remainTime = duration - currentTime
          if (currentTime && currentTime !== duration) {
            if ((this.timetick % 10) == 0) {
              localStorage.setItem(
                'currentTime_' +
                  this.mediaInfo.videoInfo.id +
                  '_' +
                  this.mediaInfo.episode,
                currentTime
              )
            }
            if ((this.timetick % 60) == 0) {
              this.saveRemainTime(remainTime, currentTime)
            }
          }
          ++this.timetick
        }
      } else {
        player.controls(false)
      }
    },
    onPlayerLoadeddata(player) {
      let currentTime = localStorage.getItem(
        'currentTime_' +
          this.mediaInfo.videoInfo.id +
          '_' +
          this.mediaInfo.episode
      )
      // 判断是否为广告或者试看内容，不是则读取视频播放进度
      if (!this.source[0].sign && this.mediaInfo.permission) {
        player.currentTime(currentTime)
      }

      let volume = localStorage.getItem(
        'volume_' + this.mediaInfo.videoInfo.id
      )
      if (volume && parseFloat(volume) != player.volume()) {
        player.volume(parseFloat(volume))
      }
    },
    // 保存观看历史
    saveRemainTime(remainTime, currentTime) {
      if (typeof this.mediaInfo.videoFileId === 'object') {
        this.mediaInfo.videoFileId = this.mediaInfo.videoFileId[0]
        this.mediaInfo.duration = this.mediaInfo.duration[0]
      }
      if (getUser() && getToken()) {
        this.insertHistory(remainTime, currentTime)
        // var that = this
        // this.querier({
        //   url: '/realNet/history/getHistories',
        //   method: 'GET',
        //   params: {
        //     categoryId: this.mediaInfo.categoryId, // 栏目ID
        //     name: this.mediaInfo.name, // 视频名称
        //     videoFileId: this.mediaInfo.videoFileId , // 视频文件ID
        //     type: 1 // 观看历史
        //   },
        //   headers: {
        //     token: getToken()
        //   }
        // })
        //   .then(res => {
        //     if (
        //       res.data.result &&
        //       res.data.result.content &&
        //       !that.favorated(res.data.result.content)
        //     ) {
        //       that.insertHistory(remainTime)
        //     } else {
        //       that.updateHistory(remainTime)
        //     }
        //   })
        //   .catch(error => {
        //     console.log(error)
        //   })
      }
    },
    favorated: function(records) {
      for (let i = 0; i < records.length; ++i) {
        if (
          records[i].videoInfo.videoName == this.mediaInfo.name &&
          records[i].videoFileId == this.mediaInfo.videoFileId
        ) {
          return true
        }
      }
      return false
    },
    insertHistory(remainTime, currentTime) {
      this.querier({
        url: '/realNet/history/insert',
        method: 'POST',
        data: Object.assign(
          {
            customerId: JSON.parse(getUser()).id, // 客户id
            remainingTime: remainTime, // 剩余时长
            type: 1, // 观看历史
            watched: currentTime
          },
          this.mediaInfo
        ),
        headers: {
          token: getToken()
        }
      }).catch(error => {
        console.log(error)
      })
    },
    updateHistory(remainTime) {
      this.querier({
        url: '/realNet/history/save',
        method: 'PUT',
        data: Object.assign(
          {
            customerId: JSON.parse(getUser()).id, // 客户id
            remainingTime: remainTime, // 剩余时长
            infoId: this.mediaInfo.videoInfo.id, // 视频ID
            type: 1 // 观看历史
          },
          this.mediaInfo
        ),
        headers: {
          token: getToken()
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 设置音量
    saveVolume(player) {
      localStorage.setItem(
        'volume_' + this.mediaInfo.videoInfo.id,
        player.volume()
      )
    },
    // 跳过广告
    vipClose() {
      if (getUser()) {
        if (this.mediaInfo.permissionAds) {
          clearInterval(this.timer)
          this.timing = 0
          // 移除广告source
          this.source.shift()
        } else {
           this.callPay('您还不是VIP用户，暂时无法享受相关权益')
        }
      } else {
        this.callLogin('您还未登录，请先登录')
      }
    },
    // 检查是否为VIP用户
    checkVip(e) {
      let memberExpireTime = JSON.parse(getUser()).memberExpireTime
      if(!memberExpireTime) {
        if(!e) {
          this.callPay('您还不是VIP用户，暂时无法享受相关权益')
        }
        return false
      } else {
        let now = new Date()
        let vipTime = new Date(memberExpireTime)
        if ((vipTime - now) < 0) {
          if(!e) {
            this.callPay('您的VIP权益已到期，请续费获取相关权益')
          }
        return false
        } else {
          return true
        }
      }
    },
    // 购买视频
    purchase(e) {
      if (getUser()) {
        // 通知去支付
        this.callPay('', e)
      } else {
        this.callLogin('您还未登录，请先登录')
      }
    },
    // 去登录
    callLogin(msg) {
      this.$message({
        message: msg,
        type: 'warning',
        duration: 1000,
        onClose: () => {
          this.$emit('login')
        }
      })
    },
    // 去购买/开通VIP
    callPay(msg, type) {
      if (msg) {
        this.$message({
          message: msg,
          type: 'warning',
          duration: 1000,
          onClose: () => {
            this.$emit('purchase', type || 'vip')
          }
        })
      } else {
        this.$emit('purchase', type)
      }
    },
    // 添加广告观看点击次数
    insertAdcount(type, id) {
      this.querier({
        url: '/realNet/advertisement/times',
        method: 'GET',
        params: {
          type: type, // 1观看 2点击
          id: id
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.player {
  height: 576px;
  position:relative;
}
.player .vjs-progress-control {
  position: absolute !important;
  top: -5px !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  height: 4.2px !important;
}
.player .vjs-progress-control .vjs-progress-holder {
  margin: 0 !important;
}
.player .vjs-fullscreen-control {
  position: absolute !important;
  right: 0 !important;
}
.player .vjs-cog-control {
  position: absolute !important;
  right: 42px !important;
}
.player .vjs-playback-rate {
  position: absolute !important;
  right: 42px !important;
}
.player .vjs-clarity {
  position: absolute !important;
  right: 126px !important;
}
.player .vjs-clarity .vjs-clarity-value {
  font-size: 1.2em;
  line-height: 2.4;
}
.player .video-information {
  width: 100%;
  height: 42px;
  background-color: rgb(43, 51, 63);
}
.player .video-information .video-left {
  float: left;
}
.player .video-information .video-right {
  float: right;
}
.player .video-information > ul > li {
  float: left;
  position: relative;
  font-size: 12px;
  line-height: 42px;
  color: #fff;
  margin: 0 12px;
  cursor: pointer;
}
.player .video-information > ul > li .video-icon {
  margin-right: 4px;
  font-size: 14px;
}
.player .vjs-custom-skin{
   width: 100%;
   height:100%;
}
.player #cover{
   width: 100%;
   height:90%;
   position:absolute;
   top:0;
   left:0;
}

.tips {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0px;
  position: relative;
  bottom: 91%;
  left: 80%;
  width: 150px;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  font-size: 13px;
  .timing {
    display: flex;
    align-items: center;
    height: 14px;
    padding: 0px 8px;
    color: #ff6e0b;
    border-right: 1px solid #3b3b3b;
  }
  .vip-close {
    cursor: pointer;
    span {
      padding-right: 8px;
    }
  }
}
.video-player /deep/ .video-js /deep/ .pause-ads {
  position: relative;
  left: 20%;
  top: 25%;
  height: 50%;
  width: 60%;
  .close {
    position: absolute;
    top: 2px;
    right: 6px;
    padding: 2px 6px;
    font-size: 13px;
    cursor: pointer;
    color: #fff;
    background: rgba(0,0,0, 0.5);
  }
  & > a {
    display: inline-block;
    height: 100%;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.limit-watch {
    position: absolute;
    left: 2%;
    top: 87%;
    padding: 4px 8px;
    font-size: 13px;
    color: #fff;
    background: rgba(0, 0, 0, 0.6);
    .sample {
      color: #ff6e0b;
    }
    .purchase {
      cursor: pointer;
      color: #ff6e0b;
    }
}
.jump-ad {
  position: relative;
  bottom: 90%;
  height: 80%;
  & > a {
    display: inline-block;
    height: 100%;
    width: 100%;
  }
}
</style>